import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AuthContext } from '../../../component/context/AuthContext';
import axios from "axios";
import { toast } from "react-toastify";
import * as  CONST from "../../../component/config/Constant";
import moment from 'moment';
import {
  IconCalendar, IconClock, IconMail, IconMessage, IconChecklist,
  IconCalendarEvent, IconUser, IconBriefcase, IconUsers
} from '@tabler/icons-react';
import '../employee/employee-details.css';

const ViewLeaveDetails = ({ closeLeave, editLeaveId, viewData }) => {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [show, setShow] = useState('show');
  const [loading, setLoading] = useState(false);
  const [empDetails, setEmpDetails] = useState('');
  let isToken = '';
  let user_id = '';
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      user_id = authUserData[0].user_id ? authUserData[0].user_id : "";
    }
  }

  const formatTime = (date) => {
    return date.slice(0, -3);
  }
  const formatDate = (date) => {
    return moment(date).format('DD-MM-YYYY HH:mm')
  }
  const fetchEmployee = async () => {
    await axios
      .post(CONST.GET_EMP_BY_ID, {
        id: viewData.user_id,
        user_id: viewData.user_id
      }, {
        headers: {
          'Authorization': `Bearer ${isToken}`
        }
      })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setLoading(true);
          setEmpDetails(response.data.data);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  }

  useEffect(() => {
    fetchEmployee();
  }, []);

  return (
    <Modal
      show={show}
      onHide={() => closeLeave("hide")}
      backdrop="static"
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Leave Details</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0 bg-light overflow-auto">
        <div className="container-fluid px-md-4 py-3">
          <div className="row justify-content-center g-4">
            {/* Left Sidebar: Profile & Basic Info */}
            <div className="col-10 col-md-4 left-sidebar emp-detail-left">
              <div className="card border w-100" style={{ borderColor: '#e2e8f0' }}>
                <div className="card-body ">
                  <div className="text-center mb-1">
                    <div className="employee-img mb-3 mt-3">
                      {empDetails?.profile_photo_path ? (
                        <img
                          src={CONST.HOST + empDetails.profile_photo_path}
                          alt="Profile"
                          className=""
                        />
                      ) : (
                        <span className="rounded-circle bg-white text-primary d-flex align-items-center justify-content-center shadow-sm" style={{ fontSize: '30px', fontWeight: '700' }}>
                          {viewData.user?.first_name?.charAt(0)}{viewData.user?.last_name?.charAt(0)}
                        </span>
                      )}
                    </div>
                    <h4 className="card-title mb-1 pt-3">
                      {viewData.user?.first_name} {viewData.user?.last_name}
                    </h4>
                  </div>

                  <hr />

                  <ul className="personal-info">
                    <li>
                      <IconMail size={18} />
                      <span className="text-truncate" title={empDetails?.email}>{empDetails?.email || 'N/A'}</span>
                    </li>
                    <li>
                      <IconBriefcase size={18} />
                      {empDetails?.department?.name || 'Department'} / {empDetails?.designation?.name || 'Designation'}
                    </li>
                    <li>
                      <IconCalendarEvent size={18} />
                      {viewData.leave_type} {viewData.e_leave_type?.name && `(${viewData.e_leave_type.name})`}
                    </li>
                    <li>
                      <IconCalendar size={18} />
                      {moment(viewData.leave_from_date).format("DD-MM-YYYY")}
                      {viewData.leave_type_id == '1' && ` to ${moment(viewData.leave_to_date).format("DD-MM-YYYY")}`}
                    </li>
                    <li>
                      <IconClock size={18} />
                      {viewData.from_time ? `${formatTime(viewData.from_time)} - ${formatTime(viewData.to_time)}` : '00:00 - 00:00'}
                    </li>
                    <li>
                      <IconUser size={18} />
                      Applied: {formatDate(viewData.leave_applied_date)}
                    </li>
                  </ul>

                  <div className="mt-4 text-center">
                    <div className="badge rounded-pill bg-white text-primary px-3 py-2 shadow-sm" style={{ fontWeight: '700', letterSpacing: '0.5px' }}>
                      STATUS : {
                        viewData.status == 1 ? "APPROVED" :
                          viewData.status == 2 ? "REJECTED" :
                            viewData.status == 3 ? "CANCELLED" : "PENDING"
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Content Sections */}
            <div className="col-12 col-md-8 right-sidebar emp-detail-right">
              <div className="card border h-100 p-3" style={{ borderRadius: '10px', borderColor: '#e2e8f0' }}>
                {/* Recipients */}
                <div className="mb-4">
                  <h4><IconUsers size={20} /> Recipient List</h4>
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    {viewData.leaveToMailData?.map((e, i) => (
                      <span key={`to-${i}`} className="badge bg-light text-primary border px-2 py-1" style={{ fontSize: '11px' }}>
                        <span className="opacity-50 me-1">To:</span> {e.leaveToMailUserData?.first_name} {e.leaveToMailUserData?.last_name}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Subject & Content */}
                <div className="mb-4">
                  <h4><IconMail size={20} /> Leave Subject</h4>
                  <div className="mt-2 text-dark fw-bold mb-3" style={{ fontSize: '14px' }}>
                    <span dangerouslySetInnerHTML={{ __html: viewData.subject }} />
                  </div>
                  <div className="card border-0 bg-light p-3" style={{ borderRadius: '10px' }}>
                    <div className="text-secondary" style={{ lineHeight: '1.6', fontSize: '13px' }}>
                      <span dangerouslySetInnerHTML={{ __html: viewData.reason }} />
                    </div>
                  </div>
                </div>

                {/* Reviewer Comments */}
                <div className="mt-2 pt-2 border-top">
                  <h4><IconMessage size={20} /> Reviewer Comments</h4>
                  <div className="p-3 border rounded shadow-xs bg-white mt-2" style={{ borderLeft: '3px solid #1167e8' }}>
                    <div className="text-muted small" style={{ fontSize: '13px' }}>
                      {viewData.leave_comment || 'No comments have been provided for this application yet.'}
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-start mt-auto pt-4">
                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => closeLeave("hide")}
                    style={{ borderRadius: '8px', fontSize: '13px' }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewLeaveDetails;